import api from './api'

export const getWhereDidYouMeetUs = () => api.get('/where_you_met/')
